import * as React from 'react'
import { Box, styled } from '@mui/material'
import { Typography as MIUTypography } from '@mui/material'

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '1em',
  fontWeight: props.istitle ? 700 : 450,
  lineHeight: '24px',
  color: props.istitle ? '#1B1C37' : '#6A6A6A',
  textAlign: 'center',
}))
const Italic = ({ words }) => <span style={{ fontStyle: 'italic' }}>{words}</span>

const Introduction = () => {
  return (
    <Box>
      <Typography sx={{ textAlign: 'justify' }}>
        El arbolado urbano proporciona servicios ecosistémicos esenciales para el
        desarrollo sostenible de las ciudades. No obstante, el conocimiento actual sobre
        los árboles urbanos en nuestra región es limitado. Por ello, este estudio se
        centró en caracterizar la composición forística y estructura del arbolado urbano
        en la ciudad de Loja, Ecuador. Para ello, se realizó un inventario exhaustivo de
        los árboles mayores a cinco centímetros de diámetro (DAP ≥ 5cm) en las principales
        avenidas y parques del casco urbano de la ciudad de Loja. Se describió la
        composición forística a nivel taxonómico, considerando su origen y hábito de
        crecimiento. Como resultado de este inventario forestal se registraron 5259
        individuos que corresponden a 91 especies, 67 géneros, y 35 familias con hábitos
        de crecimiento arbóreo, arbustivo, y palmas. La familia Fabaceae tuvo la mayor
        riqueza con 17 especies identifcadas, seguida de las familias Myrtaceae (11 sp.) y
        las familias Bignoniaceae, Moraceae y Rosaceae con 5 especies cada una. De las 91
        especies identifcadas, se encontró que 34 (37,36%) especies fueron nativas y 57
        (62,64%) fueron exóticas. <Italic words="Salix humboltiana" /> se destacó como la
        especie más abundante, seguida de <Italic words="Jacaranda mimosifolia" />,{' '}
        <Italic words="Alnus acuminata" />, <Italic words="Vachellia macracantha" />, y{' '}
        <Italic words="Fraxinus chinensis" />. Por lo tanto, es importante resaltar que un
        inventario forestal es una herramienta valiosa y un soporte esencial para la toma
        de decisiones en la planifcación y gestión del arbolado urbano.
      </Typography>
    </Box>
  )
}

export default Introduction
